import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';

const Home = lazy(() => import('@/pages/home/page'));
const ServicesPage = lazy(() => import('@/pages/services/page'));
const CaseStudyPage = lazy(() => import('@/pages/case-study/page'));
const AboutPage = lazy(() => import('@/pages/about/page'));
const ContactPage = lazy(() => import('@/pages/contact/page'));
const PrivacyPage = lazy(() => import('@/pages/privacy/page'));
const TermsPage = lazy(() => import('@/pages/terms/page'));
const BlogPage = lazy(() => import('@/pages/blog/page'));
const BlogDetailPage = lazy(() => import('@/pages/blog/[slug]/page'));
const AdminPage = lazy(() => import('@/pages/admin/page'));

const PageFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-8 h-8 border-2 border-[#1E6FFF] border-t-transparent rounded-full animate-spin" />
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<PageFallback />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/services',
    element: (
      <Suspense fallback={<PageFallback />}>
        <ServicesPage />
      </Suspense>
    ),
  },
  {
    path: '/case-study',
    element: (
      <Suspense fallback={<PageFallback />}>
        <CaseStudyPage />
      </Suspense>
    ),
  },
  {
    path: '/about',
    element: (
      <Suspense fallback={<PageFallback />}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<PageFallback />}>
        <ContactPage />
      </Suspense>
    ),
  },
  {
    path: '/privacy',
    element: (
      <Suspense fallback={<PageFallback />}>
        <PrivacyPage />
      </Suspense>
    ),
  },
  {
    path: '/terms',
    element: (
      <Suspense fallback={<PageFallback />}>
        <TermsPage />
      </Suspense>
    ),
  },
  {
    path: '/blog',
    element: (
      <Suspense fallback={<PageFallback />}>
        <BlogPage />
      </Suspense>
    ),
  },
  {
    path: '/blog/:slug',
    element: (
      <Suspense fallback={<PageFallback />}>
        <BlogDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<PageFallback />}>
        <AdminPage />
      </Suspense>
    ),
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
